<div class="page-not-found">
  <h1>404</h1>
  <h2>Page Not Found</h2>
  <p>
    The page you are looking for might have been removed, had its name changed,
    or is temporarily unavailable.
  </p>
  <a routerLink="/">Go to Home</a>
</div>
